import mapValues from 'lodash/mapValues.js'

/** Maps -1 values to Infinity */
export const mapNegativeToInfinity = <T extends object>(data: T): T =>
	mapValues(data, (value) => ((value as any) === -1 ? Infinity : value)) as T
